import React, { Component } from "react";


import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import CampaignDeviceTypeModal from "./components/CampaignDeviceTypeModal";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import {
  addCampaignDeviceType,
  deleteCampaignDeviceType,
  getCampaignDeviceTypesList,
  updateCampaignDeviceTypeProfile,
} from "../../../store/campaigns/device-types/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class DeviceTypes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddCampaignDeviceTypes: false,
      editData: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getCampaignDeviceTypesList(this.props.data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleTableChange = data => {
    this.props.getCampaignDeviceTypesList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddDeviceTypesModal = () => {
    this.setState(prevState => ({
      viewAddCampaignDeviceTypes: !prevState.viewAddCampaignDeviceTypes,
      editData: null,
    }));
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.name}"!`,
          onConfirm: () => {
            this.props.deleteCampaignDeviceType(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row, "edit");
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_campaigndevicetypemodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_campaigndevicetypemodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const onClickRow = (e, row, type) => {
      if (this.props.permissions?.["view_campaigndevicetypemodel"]) {
        this.setState(prevState => ({
          viewAddCampaignDeviceTypes: !prevState.viewAddCampaignDeviceTypes,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "name"),
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "description"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <React.Fragment>
        {this.state.viewAddCampaignDeviceTypes && (
          <CampaignDeviceTypeModal
            toggle={this.toggleViewAddDeviceTypesModal}
            isOpen={this.state.viewAddCampaignDeviceTypes}
            data={this.props.data}
            addCampaignDeviceType={this.props.addCampaignDeviceType}
            updateCampaignDeviceTypeProfile={
              this.props.updateCampaignDeviceTypeProfile
            }
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}

        <div className="page-content">
        <ModifiedMetaTags title="Campaign devise types | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Campaign device types"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this device type? <br /> If you are
                  not sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions &&
                        this.props.permissions[
                          "add_campaigndevicetypemodel"
                        ] === "add_campaigndevicetypemodel" && (
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={this.toggleViewAddDeviceTypesModal}
                          >
                            <i className="mdi mdi-plus me-1" /> Add campaign
                            device type
                          </Button>
                        )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

DeviceTypes.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignDeviceTypesList: PropTypes.func,
  addCampaignDeviceType: PropTypes.func,
  deleteCampaignDeviceType: PropTypes.func,
  updateCampaignDeviceTypeProfile: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.CampaignDeviceTypeList.data,
  loading: state.CampaignDeviceTypeList.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getCampaignDeviceTypesList,
  addCampaignDeviceType,
  deleteCampaignDeviceType,
  updateCampaignDeviceTypeProfile,
})(DeviceTypes);
